import React from "react";

export const MACHINE_MAINTENANCE_HELP_TITLE = "Manutenção de Máquinas";

export function MachineMaintenanceHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Centralizar o{" "}
        <strong>histórico e os próximos serviços</strong> de todas as máquinas
        da fazenda — em um só lugar, para gestores e operadores.
      </p>

      <p>
        <strong>O que você vê nesta área:</strong>
      </p>
      <ul>
        <li>
          manutenções já realizadas em cada equipamento;
        </li>
        <li>
          <strong>próxima manutenção</strong> programada e{" "}
          <strong>horas restantes</strong> até a revisão;
        </li>
        <li>
          detalhes do serviço — por exemplo:{" "}
          <strong>óleo utilizado e viscosidade</strong>,{" "}
          <strong>filtro de combustível</strong> (marca e número), filtros de
          ar e demais peças trocadas;
        </li>
        <li>
          <strong>horímetro atualizado</strong> de cada máquina.
        </li>
      </ul>

      <p>
        <strong>Alertas automáticos:</strong>
      </p>
      <ul>
        <li>
          a plataforma <strong>avisa quando a próxima troca se aproxima</strong>{" "}
          (ex.: troca de óleo, filtro, revisão programada);
        </li>
        <li>
          há <strong>alerta visual na plataforma</strong> quando alguma máquina
          está com manutenção <strong>vencida</strong> — por exemplo, troca de
          óleo em atraso.
        </li>
      </ul>

      <p>
        <strong>Como registrar uma manutenção:</strong>
      </p>
      <ul>
        <li>
          <strong>Na plataforma web</strong> — em Equipamentos → Máquina →
          Agendamentos;
        </li>
        <li>
          <strong>No app de campo</strong> — quando o operador executa a
          manutenção no campo, ele registra o que foi feito, informa o
          intervalo até a próxima revisão e vê quantas horas faltam; os mesmos
          dados aparecem aqui automaticamente.
        </li>
      </ul>

      <p>
        Quanto mais detalhes forem informados (óleo, filtros, números de peça),
        melhor fica o histórico e mais precisos são os avisos de próxima troca.
      </p>
    </>
  );
}
